module.exports = __webpack_public_path__ + "img/30290-1-122.prt.b8263cff.jpg";